import { isEmptyObject } from "../../../lib/utils";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

export const formValidator = (values, t) => {
  let formErrors = {};
  let CreateFrom = values["CreateFrom"];
  let File = values["File"];
  let SelectedSheet =  values["SelectedSheet"];
  let DatasetName = values["DatasetName"];
  let DatasetTitle = values["DatasetTitle"];

  if (!CreateFrom) {
    formErrors = Object.assign(formErrors, {
      CreateFrom: t("datasets.create.createfrom_error"),
    });
  }

  if (!File) {
    formErrors = Object.assign(formErrors, {
      File: t("datasets.create.file_error2"),
    });
  }

  if (!SelectedSheet) {
    formErrors = Object.assign(formErrors, {
      SelectedSheet: t("datasets.create.sheet_error"),
    });
  }

  if (!DatasetName) {
    formErrors = Object.assign(formErrors, {
      DatasetName: t("datasets.create.datasetname_error"),
    });
  }

  if (!DatasetTitle) {
    formErrors = Object.assign(formErrors, {
      DatasetTitle: t("datasets.create.datasettitle_error"),
    });
  }
  //console.log(formErrors)
  if (isEmptyObject(formErrors)) return undefined;
  //console.log("formErrors", formErrors);
  return formErrors;
};
